import React from 'react';
import PropTypes from 'prop-types';
import { FlexColumn } from 'web-ui-components/lib/global/layout';
import { longDateFormat } from '../../../config';
import { formatSortCode } from '../../../utils/accountUtils';
import BacsHeaderRow from '../BacsHeaderRow/BacsHeaderRow';

const BacsSummary = ({ bacsDetails, accountLabel, account, content, bacsTypeHeader, dateLabel }) => {
	const formatAccount = ({
		metadata = '',
		accountNumber = '',
		sortCode = '',
		displayName = '',
		type = '',
		number = '',
	}) => {
		if (metadata.account_name) {
			return `${metadata.account_name} | ${displayName} | ${formatSortCode(sortCode)} | ${accountNumber}`;
		}
		if (type === 'credit_card') {
			return `${displayName} | ${number}`;
		}
		return `${displayName} | ${formatSortCode(sortCode)} | ${accountNumber}`;
	};

	const { paymentTypeLabel, bacsIdLabel, submissionDateLabel, numberOfPaymentsLabel } = content;
	return (
		<FlexColumn gutter={1}>
			<div className="u-flex-full-height">
				<BacsHeaderRow key={paymentTypeLabel} label={paymentTypeLabel} value={bacsTypeHeader} />
				<BacsHeaderRow key={accountLabel} label={accountLabel} value={formatAccount(account)} />
				<BacsHeaderRow key={bacsIdLabel} label={bacsIdLabel} value={bacsDetails.bacsId} />
				<BacsHeaderRow
					key={submissionDateLabel}
					label={submissionDateLabel}
					value={bacsDetails.submissionDate.format(longDateFormat)}
				/>
				<BacsHeaderRow key={dateLabel} label={dateLabel} value={bacsDetails.settlementDate.format(longDateFormat)} />
				<BacsHeaderRow key={numberOfPaymentsLabel} label={numberOfPaymentsLabel} value={bacsDetails.payments.length} />
			</div>
		</FlexColumn>
	);
};

BacsSummary.propTypes = {
	bacsDetails: PropTypes.shape({}).isRequired,
	account: PropTypes.shape({
		accountNumber: PropTypes.string,
		sortCode: PropTypes.string,
		displayName: PropTypes.string,
	}).isRequired,
	dateLabel: PropTypes.string.isRequired,
	bacsTypeHeader: PropTypes.string.isRequired,
	accountLabel: PropTypes.string.isRequired,
	content: PropTypes.shape({
		paymentTypeLabel: PropTypes.string,
		fromLabel: PropTypes.string,
		bacsIdLabel: PropTypes.string,
		submissionDateLabe: PropTypes.string,
		settlementDateLabel: PropTypes.string,
		numberOfPaymentsLabel: PropTypes.string,
		toLabel: PropTypes.string,
	}).isRequired,
};

export default BacsSummary;
